import { getInitialValues } from "layouts/views/common/common";
import * as Yup from "yup";

const formField = {
  locDimGrp: {
    name: "locDimGrp",
    label: "Location Dimension Group",
    type: "text",
    errorMsg: "Location Dimension Group is required.",
    required: true,
    editable: false,
  },
  locGrpType: {
    name: "locGrpType",
    label: "Location Group Type",
    type: "select",
    required: true,
  },
  grossDepth: { name: "grossDepth", label: "Gross Depth", type: "number" },
  grossHeight: { name: "grossHeight", label: "Gross Height", type: "number" },
  grossWidth: { name: "grossWidth", label: "Gross Width", type: "number" },
  volumeCBM: { name: "volumeCBM", label: "Volume CBM", type: "number" },
  maxWeight: { name: "maxWeight", label: "Max Weight", type: "number" },
  volumeUOM: {
    name: "volumeUOM",
    label: "Volume UOM",
    type: "select",
  },
  weightUOM: {
    name: "weightUOM",
    label: "Weight UOM",
    type: "select",
  },
};

const {
  locDimGrp,
  locGrpType,
  grossDepth,
  grossWidth,
  grossHeight,
  volumeCBM,
  maxWeight,
  volumeUOM,
  weightUOM,
} = formField;

export const formRender = [
  [locDimGrp, locGrpType],
  [
    {
      //if u want to wrap field
      type: "fieldset",
      label: "Dimension",
      fieldsetRender: [
        [grossDepth, grossHeight, grossWidth],
      ],
    },
  ],
  [
    {
      //if u want to wrap field
      type: "fieldset",
      label: "Volume",
      fieldsetRender: [
        [volumeCBM, volumeUOM],
      ],
    },
  ],
  [
    {
      //if u want to wrap field
      type: "fieldset",
      label: "Weight",
      fieldsetRender: [
        [maxWeight, weightUOM],
      ],
    },
  ],
];

export const initialValues = getInitialValues(formField);

export const locationGroupValidations = Yup.object().shape({
  [locDimGrp.name]: Yup.string().nullable().max(20).required(locDimGrp.errorMsg),
  [grossDepth.name]: Yup.number().min(0),
  [grossHeight.name]: Yup.number().min(0),
  [grossWidth.name]: Yup.number().min(0),
  [volumeCBM.name]: Yup.number().min(0),
  [maxWeight.name]: Yup.number().min(0),
});
